import React from "react";
import { TextEntryFormControl } from "../TextEntryFormControl";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
import { PropertyEditorSelect } from "../../../CommonUI/PropertyEditing/PropertyEditorSelect";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { Variant as TextVariant } from "@mui/material/styles/createTypography";
import { StyledFormHelperText } from "./CommonStyled";
import { IssueData } from "../../Utilities/ControlRenderContext";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { PropertyEditorCollapse } from "../../../CommonUI/PropertyEditing/PropertyEditorCollapse";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";

export class MultiInlineTextEditFormControl extends TextEntryFormControl {
    readonly __type: string = "Multi Inline Text";
    type: TextVariant = "h6";

    focusControl() {
        this.ref.current && this.ref.current.click();
    }

    render() {
        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";
        const customWidth = this.fullWidth ? "100%" : this.width ? `${this.width}px` : "200px";

        return (
            <div>
                <InlineTextEdit
                    text={this.valueName && this.getFormDataValue(this.valueName)}
                    onEdit={(val) => this.valueName && val !== "" && this.setFormDataValue(this.valueName, val)}
                    placeholder={this.placeholderText || "Label"}
                    width={customWidth}
                    multiLine={true}
                    ref={this.ref}
                />
                <StyledFormHelperText
                    error={Boolean(issueText)}
                    data-testid="issueOrHintText"
                >
                    {issueText ? issueText : this.hintText}
                </StyledFormHelperText>
            </div>
        );
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let dd = new StringDataDefinition();
        dd.name = this.valueName;
        return dd;
    }

    renderEditUI(): JSX.Element | null {
        return <XMultiInlineTextEditUI editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "type");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "type");
    }
}

function XMultiInlineTextEditUI(props: { editMe: MultiInlineTextEditFormControl }) {
    const options: string[] = [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "subtitle1",
        "subtitle2",
        "body1",
        "caption",
        "button",
        "overline",
    ];
    return (
        <UISpacedBoxContent>
            <PropertyEditorSelect
                label={"Select Tag"}
                propertyName={"type"}
                editObject={props.editMe}
                options={options}
            />
            {props.editMe.renderBaseDataControlEditor(["label"])}
            <PropertyEditorText
                label={"Placeholder Text"}
                propertyName={"placeholderText"}
                editObject={props.editMe}
            />
            <PropertyEditorText
                label={"Hint Text"}
                propertyName={"hintText"}
                editObject={props.editMe}
            />
            <PropertyEditorBoolean
                label={"Full Width"}
                propertyName={"fullWidth"}
                editObject={props.editMe}
            />
            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"fullWidth"}
                showIfFalse={true}
            >
                <PropertyEditorInteger
                    label={"Width"}
                    propertyName={"width"}
                    editObject={props.editMe}
                />
            </PropertyEditorCollapse>
        </UISpacedBoxContent>
    );
}
